import styled from "styled-components";
import Icon from "../../../../../../components/icon";
import { theme } from "../../../../../../helpers/theme";
import { ReactComponent as DedicatedWarehouseSVG } from "../../../../../../assets/icons/warehouse-dedicated.svg";
import { ReactComponent as DedicatedWarehouseActiveSVG } from "../../../../../../assets/icons/warehouse-dedicated-active.svg";
import { ReactComponent as MultiWarehouseSVG } from "../../../../../../assets/icons/multi-warehouse.svg";
import { ReactComponent as MultiWarehouseActiveSVG } from "../../../../../../assets/icons/multi-warehouse-active.svg";
import FormFieldInfo from "../../../../../common-views/offer-form/components/form-field-info/form-field-info";
import { IsPriceVisible, TwoTypesOfOfferHandler } from "../../../helpers/types";



interface MultiWarehouseProps {
    isActive: boolean,
    isMultiWarehouseDisable: boolean,
    requires_consultation: boolean,
    isPriceVisible: IsPriceVisible,
    //isComponentNoMatchingWarehousesVisible: boolean;
    //isThePriceVisibleInMultiWarehouseButton: boolean,
    min_value: number,
    max_value: number,
    isTwoTypesOfOffer: TwoTypesOfOfferHandler,
    handleClik: (value: number) => void,
}

export const MultiWarehouse = ({
    isActive,
    isMultiWarehouseDisable,
    requires_consultation,
    isPriceVisible,
    //isComponentNoMatchingWarehousesVisible,
    //isThePriceVisibleInMultiWarehouseButton,
    min_value,
    max_value,
    isTwoTypesOfOffer,
    handleClik
}: MultiWarehouseProps) => {

    return (
        <Container
            isActive={isActive}
            onClick={() => handleClik(1)}
            disabled={isMultiWarehouseDisable ? true : (isTwoTypesOfOffer.active === 1 || isTwoTypesOfOffer.active === 2) ? false : true}
        >
            <MultiWarehouseIcon>
                <Icon
                    width="29px"
                    height="32px"
                    noPadding
                    icon={isActive ? <MultiWarehouseActiveSVG /> : <MultiWarehouseSVG />}
                />
            </MultiWarehouseIcon>
            <MultiWarehouseMessageContainer>
                <MultiWarehouseTitle isActive={isActive}>Multimagazyn</MultiWarehouseTitle>

                {((min_value === null && max_value === null) || (!isPriceVisible.value_multi_warehouse)) ?
                    <></> :
                    <MultiWarehouseValue isActive={isActive}>

                        {(min_value === -1 || max_value === -1 || min_value === Infinity || max_value === Infinity)
                            ? null
                            : (
                                min_value !== max_value
                                    ? `${min_value.toFixed(2)} - ${max_value.toFixed(2)} zł`
                                    : `${min_value.toFixed(2)} zł`
                            )

                        }
                        {/* {(min_value == -1 || max_value == -1)
                            ? null
                            : (
                                (isThePriceVisibleInMultiWarehouseButton ? (
                                    min_value !== max_value
                                        ? `${min_value.toFixed(2)} - ${max_value.toFixed(2)} zł`
                                        : `${min_value.toFixed(2)} zł`) : null
                                ))
                        } */}

                        {requires_consultation ? <span> (Konsultacja)</span> : null}

                    </MultiWarehouseValue>}

            </MultiWarehouseMessageContainer>
            <InfoWrapper>
                <FormFieldInfo
                    noPadding={true}
                    popoverLabel={""}
                    popoverContent={"Lorem Ipsum 2"}
                />
            </InfoWrapper>
        </Container>
    );
};



const Container = styled.button<{ isActive: boolean }>`
position:relative;
display:flex;
flex-direction: row;
flex-wrap:wrap;
justify-content:flex-start;
align-items:center;
border: 1px solid #0100C6;
border: ${(props: any) => (props.isActive ? `1px solid ${theme.colors.blue01_active}` : `1px solid ${theme.colors.gray02_border}`)};
border-radius: 8px;
width:49%;
min-width:250px;
padding: 20px 16px;
background-color:${theme.colors.gray04_background};
cursor: pointer;
 :hover {
     border: 1px solid ${theme.colors.gray02_border};
     box-shadow: 1px 1px 1px ${theme.colors.gray02_border};
   }
:disabled{
    border-color: ${theme.colors.gray02_border};
    opacity: 0.4;
    cursor: pointer;
    box-shadow: none;
    cursor:none;
}
`;
const MultiWarehouseIcon = styled.div`
width:20%;
`;
const MultiWarehouseMessageContainer = styled.div`
display:flex;
flex-direction: column;
flex-wrap:wrap;
justify-content:flex-start;
padding-left:15px;
width:70%;
`;
const MultiWarehouseTitle = styled.div<{ isActive: boolean }>`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color: ${(props: any) => (props.isActive ? `${theme.colors.blue01_active}` : `${theme.colors.black_primaryText}`)};
text-align: left;
`;
const MultiWarehouseValue = styled.div<{ isActive: boolean }>`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 12px;
line-height: 18px;
color: ${(props: any) => (props.isActive ? `${theme.colors.blue01_active}` : `${theme.colors.black_primaryText}`)};
text-align: left;
& span{
    color:${(props: any) => (props.isActive ? `${theme.colors.red01_alert}` : `${theme.colors.black_primaryText}`)};
}

// @media (max-width:560px){
//     max-width:150px;
//  }
`;
const InfoWrapper = styled.div`
position:absolute;
top:3px;
right:10px;
display:flex;
width:20px;
height:20px;
width:20px;
& div{
    width:20px;
    height:20px;
}

`;